<div class="from-to-calendar">
  @if(fromToCalendar.type === 'dashboard-reports'){
    <div class="from-to-calendar__dropdown-period">
      <!-- @if(fromToCalendar.type === 'dashboard-reports'){
        <button-with-text-menu-arrow
          [item]="fromToCalendar.calendarOptionItem"
          [list]="fromToCalendar.calendarOptionList"
          [selectedOption]="fromToCalendar.selectCalendarOption"
          (launchActionEmitter)="selectOption($event.option)">
        </button-with-text-menu-arrow>
      } -->

      <p-dropdown #dropdownModule
        [options]="fromToCalendar.calendarOptionList"
        [(ngModel)]="fromToCalendar.selectCalendarOption"
        (onShow)="openDropdown = !openDropdown"
        (onHide)="openDropdown  = !openDropdown"
        optionLabel="name"
        [showClear]="false"
        [dropdownIcon]="openDropdown?'lf-icon-angle-up':'lf-icon-angle-down' + ' common-icon__md'"
        class="max-w-[200px]"
        styleClass="common-dropdown__element-dark"
        panelStyleClass="common-dropdown__element-overlay"
        [placeholder]="'common.all-options' | afTranslate">
        <ng-template pTemplate="selectedItem">
          <span-tooltip [text]="fromToCalendar.selectCalendarOption?.text"
            [tooltipPosition]="'top'">
          </span-tooltip>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <button class="common-dropdown-list__si-button"
            type="button"
            (click)="selectOption(item)">
            <span-tooltip class="common-dropdown-list__si-text-container"
              [text]="item.text"
              [tooltipPosition]="'top'">
            </span-tooltip>
          </button>
        </ng-template>
      </p-dropdown>
    </div>
  }
  <div>
    @if(fromToCalendar.type !== 'hidden-headers'){
    <div class="from-to-calendar__header">
      @if (!fromToCalendar.hasError) {
        <div class="from-to-calendar__header-dates"
          [ngClass]="{'from-to-calendar__block-select-calendar-normal': isLanding}">
          <p class="from-to-calendar__date">
            @if (fromToCalendar.from === null) {
              <span [afTranslate]="'dashboard-reports.start-date'"></span>
            }@else {
              <span>{{fromToCalendar.from | convertDate: 'from-to-calendar'}}</span>
            }
          </p>
          <i class="lf-icon-arrow-right common-icon__md common-icon__main"></i>
          <p class="from-to-calendar__date">
            @if (fromToCalendar.to === null) {
              <span [afTranslate]="'dashboard-reports.end-date'"></span>
            }@else {
              <span >{{fromToCalendar.to | convertDate: 'from-to-calendar'}}</span>
            }
          </p>
        </div>
        <div class="from-to-calendar__days-between">
          <div class="common-tag__neutral-light from-to-calendar__days-left">
            <span class="common-tag__neutral-label-text">
              @if (fromToCalendar.selectDays && fromToCalendar.selectDays > 0) {
                {{fromToCalendar.selectDays + (getTranslateSelectDays())}}
              } @else {
                {{'dashboard-reports.select-days' | afTranslate}}
              }
            </span>
          </div>
        </div>
      }
      @if (fromToCalendar.hasError) {
        <div class="from-to-calendar__header-error"
          [ngClass]="{'from-to-calendar__header-error--dropdown': fromToCalendar.type === 'dashboard-reports'}">
          <p [afTranslate]="'dashboard-reports.dates-error'"></p>
        </div>
      }
    </div>
    }
    @if (fromToCalendar.ready) {
      <div class="from-to-calendar__body">
        <div class="common-date__two-calendars-container">
          <p-calendar #from
            class="common-date__two-calendars"
            [(ngModel)]="fromToCalendar.from"
            [inline]="true"
            [dateFormat]="'dd/mm/yy'"
            [hourFormat]="'24'"
            [firstDayOfWeek]="1"
            (onSelect)="selectDay('from')">
            <ng-template pTemplate="previousicon">
              <i class="lf-icon-angle-left common-icon__md common-icon__main"></i>
            </ng-template>
            <ng-template pTemplate="nexticon">
              <i class="lf-icon-angle-right common-icon__md common-icon__main"></i>
            </ng-template>
            <ng-template pTemplate="date" let-date>
              <div class="common-date__two-calendars-day"
                  [ngClass]="{'common-date__two-calendars-day--underline':isBetWeen(date),
                    'common-date__two-calendars-day--from':selectedDate(date, 'from'),
                    'common-date__two-calendars-day--in-other':selectedDate(date, 'to')}">
                {{date.day}}
              </div>
            </ng-template>
          </p-calendar>
          <p-calendar #to
            class="common-date__two-calendars"
            [(ngModel)]="fromToCalendar.to"
            [inline]="true"
            [dateFormat]="'dd/mm/yy'"
            [hourFormat]="'24'"
            [firstDayOfWeek]="1"
            (onSelect)="selectDay('to')">
            <ng-template pTemplate="previousicon">
              <i class="lf-icon-angle-left common-icon__md common-icon__main"></i>
            </ng-template>
            <ng-template pTemplate="nexticon">
              <i class="lf-icon-angle-right common-icon__md common-icon__main"></i>
            </ng-template>
            <ng-template pTemplate="date" let-date>
              <div class="common-date__two-calendars-day"
                  [ngClass]="{'common-date__two-calendars-day--underline':isBetWeen(date),
                  'common-date__two-calendars-day--to':selectedDate(date, 'to'),
                  'common-date__two-calendars-day--in-other':selectedDate(date, 'from')}">
                {{date.day}}
              </div>
            </ng-template>
          </p-calendar>
        </div>
    </div>
    }
  </div>
  <div class="from-to-calendar__buttons-block">
    <button class="common-button__text-noborder"
      type="button"
      (click)="restore()">
      <span class="common-button__text-title"
        [afTranslate]="'common.restore'">_Restaurar
      </span>
    </button>
    <button class="common-button__text-border"
      type="button"
      (click)="cancel()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar
      </span>
    </button>
    <button class="common-button__text"
      type="button"
      (click)="apply()">
      <span class="common-button__text-title"
        [afTranslate]="'common.apply'">_Aplicar</span>
    </button>
  </div>
</div>
